import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { AuthProvider } from './context/AuthContext';
import { ToastProvider } from './context/ToastContext';
import ProtectedRoute from './components/ProtectedRoute';
import ConditionalNavbar from './components/ConditionalNavbar';
import AnimatedBackground from './components/AnimatedBackground';
import Login from './pages/Login';
import Register from './pages/Register';
import Events from './pages/Events';
import EventDetails from './pages/EventDetails';
import DiscountPlaces from './pages/DiscountPlaces';
import Media from './pages/Media';
import AdminDashboard from './pages/AdminDashboard';
import AdminProducts from './pages/AdminProducts';
import AdminGiveaways from './pages/AdminGiveaways';
import AdminPhotographers from './pages/AdminPhotographers';
import CreateEvent from './pages/CreateEvent';
import SponsorDashboard from './pages/SponsorDashboard';
import AliensCars from './pages/AliensCars';
import AliensBikes from './pages/AliensBikes';
import Photographers from './pages/Photographers';
import Shop from './pages/Shop';
import Giveaways from './pages/Giveaways';
import './App.css';

function App() {
  return (
    <AuthProvider>
      <ToastProvider>
        <Router>
        <div className="App">
          <AnimatedBackground />
          <ConditionalNavbar />
          <Routes>
            {/* Auth routes */}
            <Route path="/login" element={<Login />} />
            <Route path="/register" element={<Register />} />
            
            {/* ========== PUBLIC ROUTES - No login required ========== */}
            {/* These pages are visible to everyone including guests */}
            <Route path="/media" element={<Media />} />
            <Route path="/aliens-cars" element={<AliensCars />} />
            <Route path="/aliens-bikes" element={<AliensBikes />} />
            <Route path="/photographers" element={<Photographers />} />
            <Route path="/shop" element={<Shop />} />
            <Route path="/giveaways" element={<Giveaways />} />
            
            {/* ========== PROTECTED ROUTES - Login required ========== */}
            {/* Events - require login */}
            <Route
              path="/events"
              element={
                <ProtectedRoute requireAuth>
                  <Events />
                </ProtectedRoute>
              }
            />
            <Route
              path="/events/:id"
              element={
                <ProtectedRoute requireAuth>
                  <EventDetails />
                </ProtectedRoute>
              }
            />
            
            {/* Discount Places - require login */}
            <Route
              path="/discount-places"
              element={
                <ProtectedRoute requireAuth>
                  <DiscountPlaces />
                </ProtectedRoute>
              }
            />
            
            {/* ========== ADMIN ROUTES - Founder only ========== */}
            <Route
              path="/admin"
              element={
                <ProtectedRoute requireAuth requireFounder>
                  <AdminDashboard />
                </ProtectedRoute>
              }
            />
            <Route
              path="/admin/products"
              element={
                <ProtectedRoute requireAuth requireFounder>
                  <AdminProducts />
                </ProtectedRoute>
              }
            />
            <Route
              path="/admin/giveaways"
              element={
                <ProtectedRoute requireAuth requireFounder>
                  <AdminGiveaways />
                </ProtectedRoute>
              }
            />
            <Route
              path="/admin/photographers"
              element={
                <ProtectedRoute requireAuth requireFounder>
                  <AdminPhotographers />
                </ProtectedRoute>
              }
            />
            <Route
              path="/admin/events/new"
              element={
                <ProtectedRoute requireAuth requireFounder>
                  <CreateEvent />
                </ProtectedRoute>
              }
            />
            
            {/* Sponsor Dashboard */}
            <Route
              path="/sponsor"
              element={
                <ProtectedRoute requireAuth>
                  <SponsorDashboard />
                </ProtectedRoute>
              }
            />
            
            {/* Default landing - redirect to photographers (public page) */}
            <Route path="/" element={<Navigate to="/photographers" replace />} />
          </Routes>
        </div>
      </Router>
      </ToastProvider>
    </AuthProvider>
  );
}

export default App;

